<p>sso-callback works!</p>
